import { skipToken } from '@reduxjs/toolkit/query';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';

export const useExteriorSectionData = (sectionName: string) => {
  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId || skipToken);

  const section = sections?.exterior?.subsections?.[sectionName];
  const subSections = section?.subsections || {};
  const images = (section?.images || []).filter(img => !!img.url);
  return { subSections, images };
};
